import * as React from 'react';
import { useSelector } from 'react-redux';

import { HeaderContainer } from './HeaderContainer';
import { HeaderContainer as RedesignHeaderContainer } from './Redesign';
import { selectIsMyHomeRedesign } from '../../selectors/experiments/myHomeRedesign';

export const HeaderLoadable: React.FC = () => {
  // TODO: После завершения эксперимента выпилить ненужное
  const isRedesignHeader = useSelector(selectIsMyHomeRedesign);
  const Header = isRedesignHeader ? RedesignHeaderContainer : HeaderContainer;

  return <Header />;
};
